"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEvents = void 0;
const RedrawEvents_1 = require("./RedrawEvents");
/** Event to update any components using a form watcher */
const getFormWatcherEvent = () => "update-form";
/** Event to any components using this named field watcher */
const getFieldWatcherEvent = (fieldName) => `update-field-${fieldName}`;
/**
 * Uses {@link RedrawEvents} to monitor form and field changes and redraw any
 * components that use the form/field
 *
 * @class
 * @internal
 */
class FormEvents extends RedrawEvents_1.RedrawEvents {
    /** Redraws callee when a form event happens */
    watchFormEvents() {
        this.watchRedrawEvents(getFormWatcherEvent());
    }
    /** Redraws callee when a field event happens */
    watchFieldEvents(fieldName) {
        this.watchRedrawEvents(getFieldWatcherEvent(fieldName));
    }
    /** Announces a form event */
    updateFormWatchers() {
        this.pushRedrawEvent(getFormWatcherEvent());
    }
    /** Announces a field event */
    updateFieldWatchers(fieldName) {
        this.pushRedrawEvent(getFieldWatcherEvent(fieldName));
    }
}
exports.FormEvents = FormEvents;
